module.exports = __webpack_public_path__ + "img/icons_32.1f56cfe9.svg";